import { render } from "./LocationBar.vue?vue&type=template&id=1563f0cd"
import script from "./LocationBar.vue?vue&type=script&lang=js"
export * from "./LocationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__